module.exports = __webpack_public_path__ + "static/img/12.727e696.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/12.png
// module id = G4wn
// module chunks = 1